import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import comunes from './areas/comunes';
import auth from './areas/auth';
import inicio from './areas/inicio';
import mercado from './areas/mercado';
import dinero from './areas/dinero';
import cuenta from './areas/cuenta';
import servidor from './areas/servidor';

export const IDIOMAS = [
  { id: 'es', corto: 'ES', nombre: 'Español' },
  { id: 'en', corto: 'EN', nombre: 'English' },
  { id: 'pt', corto: 'PT', nombre: 'Português' },
];

const AREAS = [comunes, auth, inicio, mercado, dinero, cuenta, servidor];
const CLAVE = 'p7-idioma';

// Une todas las áreas: { es: {...}, en: {...}, pt: {...} }
const DIC = { es: {}, en: {}, pt: {} };
AREAS.forEach((a) => ['es', 'en', 'pt'].forEach((l) => Object.assign(DIC[l], (a && a[l]) || {})));

const leer = () => {
  try {
    const v = localStorage.getItem(CLAVE);
    return IDIOMAS.some((i) => i.id === v) ? v : 'es';
  } catch (e) { return 'es'; }
};

let actual = leer();

const llenar = (txt, vars) =>
  vars ? String(txt).replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m)) : txt;

/** Traducción fuera de componentes (usa el idioma activo). Cae a español y luego a la clave. */
export const translate = (clave, vars) => llenar(DIC[actual][clave] ?? DIC.es[clave] ?? clave, vars);

// Mensajes del servidor con datos variables: 'srv:Texto {n} más texto' (cada {marcador} captura cualquier texto).
const escRe = (x) => x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const PATRONES = Object.keys(DIC.es)
  .filter((k) => k.indexOf('srv:') === 0 && /\{\w+\}/.test(k))
  .map((k) => {
    const nombres = [];
    const fuente = k.slice(4).split(/(\{\w+\})/).map((p) => {
      const m = /^\{(\w+)\}$/.exec(p);
      if (m) { nombres.push(m[1]); return '(.+?)'; }
      return escRe(p);
    }).join('');
    return { k, nombres, re: new RegExp('^' + fuente + '$') };
  });

const trSrv = (lang, msg) => {
  if (!msg || lang === 'es') return msg;
  const d = DIC[lang];
  if (d['srv:' + msg] !== undefined) return d['srv:' + msg];
  for (let i = 0; i < PATRONES.length; i += 1) {
    const m = PATRONES[i].re.exec(String(msg));
    if (m && d[PATRONES[i].k] !== undefined) {
      const vars = {};
      PATRONES[i].nombres.forEach((n, j) => { vars[n] = m[j + 1]; });
      return llenar(d[PATRONES[i].k], vars);
    }
  }
  return msg;
};

/** Mensajes que llegan del servidor en español: si hay traducción (exacta o por patrón) se usa. */
export const traducirServidor = (msg) => trSrv(actual, msg);

const Ctx = createContext({ lang: 'es', setLang: () => {}, t: translate, ts: traducirServidor, fecha: (d) => d });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(actual);
  const setLang = useCallback((l) => {
    if (!IDIOMAS.some((i) => i.id === l)) return;
    actual = l;
    try { localStorage.setItem(CLAVE, l); } catch (e) { /* sin storage */ }
    document.documentElement.setAttribute('lang', l);
    setLangState(l);
  }, []);
  const valor = useMemo(() => ({
    lang,
    setLang,
    t: (clave, vars) => llenar(DIC[lang][clave] ?? DIC.es[clave] ?? clave, vars),
    ts: (msg) => trSrv(lang, msg),
  }), [lang, setLang]);
  return <Ctx.Provider value={valor}>{children}</Ctx.Provider>;
};

export const useT = () => useContext(Ctx);
export default useT;
